import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearchOption } from '../components/util/search/searchOption';
import { urlT3 } from 'src/app/common';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  /* Gatilo para reestablecer paginador a primera pagina */
  @Output() shooterFirstPagePaginator: EventEmitter<any> = new EventEmitter();
  constructor(private http: HttpClient) { }

  private selectedOptions = new BehaviorSubject<SearchOption[]>([]);

  options$ = this.selectedOptions.asObservable();

  isOptionsEmpty$: Observable<boolean>;

  getRelatedTier3ForSeek(q: string): Observable<SearchOption[]> {
    return this.http.get<SearchOption[]>(`${urlT3}/searchTier34Seeker/` + q);
  }

  updateSelectedOptions(options: SearchOption[]) {
    this.selectedOptions.next(options);
  }

}